import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import { getCommentCount, getNewInfoIndexList, getInfoDataList } from '../../../../../../../services/api';

class ContentList extends React.PureComponent {
    static propTypes = {
        headline: PropTypes.array,
        index: PropTypes.number,
        activeIndex: PropTypes.number,
        dataKey: PropTypes.string,
        moreUrl: PropTypes.string,
        event: PropTypes.object,
        adInit: PropTypes.func,
        insertArr: PropTypes.array,
        replaceArr: PropTypes.array,
        adFn: PropTypes.func,
    };

    state = {
        isOver: false,
        len: 25,
        data: [],
        count: {},
    };

    componentDidUpdate(prevProps) {
        const { index, activeIndex, insertArr, replaceArr, adFn } = this.props;

        if (index !== activeIndex) {
            return;
        }

        if (
            (insertArr !== prevProps.insertArr || replaceArr !== prevProps.replaceArr) &&
            adFn &&
            typeof adFn === 'function'
        ) {
            const { len, data } = this.state;

            const infoData = [...data];

            const refs = [];

            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            this.setState(
                {
                    len: len + insertArr.length,
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }
    }

    async componentDidMount() {
        const { len, count } = this.state;
        const { headline, index, dataKey, adInit } = this.props;

        if (!dataKey) return;

        let data = [];

        try {
            if (index === 0) {
                data = await getNewInfoIndexList(dataKey);

                const ids = headline.filter(item => item.base62Id).map(item => item.base62Id);

                const children = headline.filter(item => item.children).map(item => item.children);

                for (const item of children) {
                    for (const child of item) {
                        if (child.base62Id) ids.push(child.base62Id);
                    }
                }

                data = data.filter(item => ids.indexOf(item.base62Id) === -1);
            } else {
                data = await getInfoDataList(dataKey);
            }

            this.setState(
                {
                    data,
                },
                () => {
                    adInit(index, data.length < len ? data.length : len);
                },
            );
        } catch (e) {
            console.error(e);
        }

        if (data && data.length > 0) {
            try {
                const docUrl = data.map(item => item.commentUrl);
                const counts = await getCommentCount(docUrl);

                counts.forEach(item => {
                    count[item.doc_url] = item.allcount;
                });

                this.setState({
                    count: { ...count },
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    /**
     * 获取更多新闻
     */
    getMore = () => {
        const { len, data } = this.state;
        const { index, event } = this.props;

        const length = len + 5;

        this.setState(
            {
                len: length,
            },
            () => {
                try {
                    event.trigger('loadMoreCmp', { index, len: data.length < len ? data.length : len });
                } catch (e) {
                    console.error(e);
                }
            },
        );
    };

    /**
     * 渲染组件
     */
    render() {
        const { len, data, count } = this.state;
        const { moreUrl } = this.props;

        /* eslint-disable no-confusing-arrow */
        return (
            <div>
                {data.length > 0
                    ? data.slice(0, len).map(
                          (item, index) =>
                              item.type === 'ad' ? (
                                  <div key={`ad_${index}`} className={styles.list} ref={item.ref} />
                              ) : (
                                  <div key={index} className={styles.list}>
                                      {item.thumbnails && item.thumbnails !== '' ? (
                                          <a href={item.url} target="_blank" className={styles.imgBox} data-innermask>
                                              <LazyImg
                                                  src={item.thumbnails}
                                                  width="144"
                                                  height="96"
                                                  className={styles.trans}
                                              />
                                          </a>
                                      ) : (
                                          ''
                                      )}
                                      <div className={styles.list_text}>
                                          <p className={styles.text}>
                                              <a href={item.url} target="_blank" title={item.title} data-innermask>
                                                  {item.title}
                                              </a>
                                          </p>
                                          <p className={styles.time}>
                                              {item.source ? <span className={styles.source}>{item.source}</span> : ''}
                                              {item.newsTime && item.newsTime !== '' ? (
                                                  <span className={styles.date}>{item.newsTime}</span>
                                              ) : (
                                                  ''
                                              )}
                                          </p>
                                      </div>
                                      {item.commentUrl ? (
                                          <div className={styles.comment}>
                                              <a
                                                  href={`//gentie.ifeng.com/c/comment/${item.base62Id}`}
                                                  target="_blank"
                                                  data-innermask>
                                                  {count[item.commentUrl]}
                                              </a>
                                          </div>
                                      ) : (
                                          ''
                                      )}
                                  </div>
                              ),
                      )
                    : ''}
                {data.length > len ? (
                    <div className={styles.more} onClick={this.getMore}>
                        加载更多
                    </div>
                ) : (
                    <a href={moreUrl} target="_blank" className={styles.all}>
                        查看更多内容
                    </a>
                )}
            </div>
        );
    }
}

export default errorBoundary(ContentList);
